import axios from 'axios';
import config from '../config';
import { getUserToken } from '../utils/helper';

export const GET_NANO_CARRIER_DETAILS = 'GET_NANO_CARRIER_DETAILS';
export const GET_NANO_CARRIER_DETAILS_SUCCESS = 'GET_NANO_CARRIER_DETAILS_SUCCESS';
export const GET_NANO_CARRIER_DETAILS_FAIL = 'GET_NANO_CARRIER_DETAILS_FAIL';
export const GET_NANO_CARRIER_DETAILS_RESET = 'GET_NANO_CARRIER_DETAILS_RESET';

export const getNanoCarrierDetails = (params) => {
	return {
		type: GET_NANO_CARRIER_DETAILS,
		params,
	};
};

export const getNanoCarrierDetailsSuccess = (response) => {
	return {
		type: GET_NANO_CARRIER_DETAILS_SUCCESS,
		response,
	};
};

export const getNanoCarrierDetailsFail = (response) => {
	return {
		type: GET_NANO_CARRIER_DETAILS_FAIL,
		response,
	};
};

export const getNanoCarrierDetailsReset = () => {
	return {
		type: GET_NANO_CARRIER_DETAILS_RESET,
	};
};

export const getNanoCarrierDetailsApi = (data) => {
	return (dispatch) => {
		dispatch(getNanoCarrierDetails());
		axios
			.get(`${config.api.base_url}/dashboard/get-nano-carrier-details`, {
				headers: {
					Authorization: 'Bearer ' + getUserToken(),
				},
			})
			.then((response) => {
				const getNanoCarrierDetailsData = response.data;
				dispatch(getNanoCarrierDetailsSuccess(getNanoCarrierDetailsData));
			})
			.catch((error) => {
				const errorMsg = error.message;
				dispatch(getNanoCarrierDetailsFail(errorMsg));
			});
	};
};
